import * as Yup from "yup";
import { Hospital_SPECIAL_CHAR_REGEX, NAME_REGEX } from "../common";

// validation schema login:
export const loginValidationSchema = Yup.object().shape({
    email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
    password: Yup.string().max(255).required("Password is required"),
});

// validation schema forgot password
export const forgotPasswordValidationSchema = Yup.object().shape({
    email: Yup.string()
        .email("Must be a valid email")
        .max(255)
        .required("Email is required"),
});

// validation schema create password
export const createNewPasswordValidationSchema = Yup.object().shape({
    password: Yup.string().max(255).required("Password is required").min(6,"Password must be at least 6 characters long."),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
});
// validation schema add hosptial
export const addHospitalValidationSchema = Yup.object().shape({
  hospitalName: Yup.string()
    .matches(Hospital_SPECIAL_CHAR_REGEX, "Enter a valid Hospital/Site Name")
    .required("Hospital/Site Name is required")
    .min(1, "Hospital/Site Name must be between 1-150 characters long")
    .max(150, "Hospital/Site Name must be between 1-150 characters long"),
    hospitalCode: Yup.string()
    .matches(/^[a-zA-Z]+$/, "Hospital/Site Code can contain characters only")
    .required("Hospital Code is required"),
  hospitalAddress: Yup.string().required("Hospital/Site Address is required"),
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
   cityCode: Yup.string().required("City Code is required"),
  pincode: Yup.string()
    .required("Pincode is required")
});
export const validateModalPopManufecturing = (type) =>{
  return Yup.object().shape({
  reason_id: Yup.mixed()?.required(type == 'pool-cycles' ? "Cycle is required": "Reason is required"),
  ...type !== 'pool-cycles' ? {remarks: Yup.string()
    .notRequired()}:{},
     reason: Yup.string()
    .when('reason_id', {
      is: (reas) => reas === 'other',
      then: Yup.string().required('Reason is required'),
      otherwise: Yup.string().notRequired()
    }),
});
}

export const cryoValidationSchema = Yup.object().shape({
  total_lsm: Yup.number()
    .notRequired(),
   blood_bags: Yup.array()
    .of(
      Yup.object().shape({
        identifier: Yup.number().required("Bag is required"),
       /* volume: Yup.number()
          .typeError("Volume must be a number")
          .required("Volume is required"),*/
        cd3_count: Yup.number()
          .typeError("CD3 count must be a number")
          .required("CD3 count is required")
          .test(
            "max-decimals",
            "At most 2 decimal places are allowed",
            (value) => {
              if (value === undefined || value === null || value === "") return true;
              const str = String(value);
              const parts = str.split('.');
              return parts.length <= 1 || parts[1].length <= 2;
            }
          ),
        storage_location_id: Yup.string()
          .required("Storage Location is required"),
      })
    )
})

export const startValidationSchema = Yup.object().shape({
   bags_id: Yup.array()              
   .required('Bags is required')
   .min(1, "Select at least one bag")
        })

// validation schema add hosptial
export const addPaymentStatusValidationSchema = Yup.object().shape({
  payment_status: Yup.string()
    .required("Payment Status is required"),
  media_id:Yup?.array().notRequired(),
  remarks: Yup.string()
    .required("Remarks is required")
});
// validation schema add hosptial
export const addProgramValidationSchema = Yup.object().shape({
  phase_type_id: Yup.string()
    .required("Phase type is required"),

  code: Yup.string()
    .required("Code is required")
    .test(
      "first-letter",
      "First character must be a letter",
      (value) => !value || /^[A-Za-z]/.test(value)
    )
     .length(4, "Code must be exactly 4 characters long")
    .test(
      "last-three-numbers",
      "Last three characters must be numeric",
      (value) => !value || /^[A-Za-z][0-9]{0,3}$/.test(value)
    )
});



// validation schema add hosptial
export const addUserSchema = Yup.object().shape({
    userType: Yup.string().max(255).required("Type is required"),
  name: Yup.string()
    .matches(NAME_REGEX, "Enter a valid Name")
    .required("Name is required")
    .min(1, "Name must be between 1-50 characters long")
    .max(50, "Name must be between 1-50 characters long"),

  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),

  countryCode: Yup.string()
    .required("Country code is required"),

  phoneNumber: Yup.string()
    .matches(/^\d+$/, "Phone number must contain digits only")
    .min(4, "Phone Number must be at least 4 digits")
    .max(15, "Phone Number must be at most 15 digits")
    .required("Phone number is required"),

  slug: Yup.string(), 
  
  hospital: Yup.mixed()
    .test('hospital-required', 'Hospital/Site is required', function(value) {
      const { slug, userType } = this.parent;
      
      if (slug === "project-manager" || Number(userType) === 2) {
        const isValid = !!(value && (Array.isArray(value) ? value.length > 0 : value));
        return isValid;
      }
      return true;
    }),
    
  principalInvestigator: Yup.mixed()
    .test('pi-required', 'Principal Investigator/HCP is required', function(value) {
      const { slug, userType } = this.parent;   
      if (slug === "project-manager") {
        return !!(value && Array.isArray(value) && value.length > 0);
      }
      if (Number(userType) === 5) {
        return !!value;
      }
      return true;
    }),
    
  trial: Yup.array()
    .when('userType', {
      is: (userType) => Number(userType) === 5,
      then: Yup.array().min(1, 'At least one Phase is required'),
      otherwise: Yup.array().notRequired()
    }),
});

// initial values for add Principal-Investigator

export const addPrincipalInvestigatorValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, "Principal/HCP Name must be between 1-50 characters long")
    .max(50, "Principal/HCP Name must be between 1-50 characters long")
    .matches(NAME_REGEX, "Enter a valid Principal/HCP Name")
    .required("Principal Investigator/HCP Name is required"),
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  countryCode: Yup.string().required("Country code is required"),
  phone: Yup.string()
    .matches(/^\d+$/, "Phone number must contain digits only")
    .min(4, "Phone Number must be at least 4 digits")
    .max(15, "Phone Number must be at most 15 digits")
    .required("Phone number is required"),
  role_id: Yup.number().required("Role Id is required"),
  hospital: Yup.string().required("Hospital/Site is required"),
});

// validation schema for add Disease-Management
export const addDiseaseManagementValidationSchema = Yup.object().shape({
  diseaseName: Yup.string()
    .matches(NAME_REGEX, "Enter a valid Disease Name")
    .required("Disease Name is required")
    .min(1, "Disease Name must be between 1-150 characters long")
    .max(150, "Disease Name must be between 1-150 characters long"),
  description: Yup.string()
    .max(255, "Description must be at most 255 characters")
    .required("Description is required"),
});

// validation schema add Editor-Management
export const addEditorValidationSchema = Yup.object().shape({
  name: Yup.string()
    .min(1, "Name must be between 1-50 characters long")
    .max(50, "Name must be between 1-50 characters long")
    .matches(NAME_REGEX, "Enter a valid Name")
    .required("Name is required"),
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  countryCode: Yup.string().required("Country code is required"),
  phoneNumber: Yup.string()
    .matches(/^\d+$/, "Phone number must contain digits only")
    .min(4, "Phone Number must be at least 4 digits")
    .max(15, "Phone Number must be at most 15 digits")
    .required("Phone number is required"),
  trial: Yup.array()
    .of(Yup.number().required("Each ID must be a number"))
    .min(1, "Phase is required"),
  principalInvestigator: Yup.number().required(
    "Principal Investigator/HCP is required"
  ),
});

export const addNewSubjectValidationSchema = (isTrial = false) => Yup.object().shape({
  first_name: Yup.string()
    .min(1, "Minumimum of 1 character")
    .max(255)
    .required(isTrial ? "First Name Initial is required" : "First Name is required")
    .matches(/^(?!\d+$).*/, isTrial ? "First Name Initial cannot be only numeric characters" : "First Name cannot be only numeric characters"),
  last_name: Yup.string()
    .min(1, "Minimum of 1 character")
    .max(255)
    .required(isTrial ? "Last Name Initial is required" : "Last Name is required")
    .matches(/^(?!\d+$).*/, isTrial ? "Last Name Initial cannot be only numeric characters" : "Last Name cannot be only numeric characters"),
  gender: Yup.string().required("Gender is required"),
  dob: Yup.string().required("Date of Birth  is required"),
  disease_id: Yup.string().required("Disease  is required"),
  form_template: Yup.string().max(255),
});


export const addNewSubjectPhaseValidationSchema = (isTrial = false) => Yup.object().shape({
  first_name: Yup.string()
    .min(1, "Minum of 1 character")
    .max(255)
    .required(isTrial ? "First Name Initial is required" : "First Name is required"),
    last_name: Yup.string()
    .min(1, "Minum of 1 character")
    .max(255)
    .required(isTrial ? "Last Name Initial is required" : "Last Name is required"),
  gender: Yup.string().required("Gender is required"),
  dob: Yup.string().required("Date of Birth  is required"),
  disease_id: Yup.string().required("Disease  is required"),
  investigator_id: Yup.string().required(
    "Principal Investigator/HCP  is required"
  ),
  editor_id: Yup.string().nullable()
});

export const editSubjectPhaseValidationSchema = (isTrial = false) => Yup.object().shape({
  first_name: Yup.string()
    .min(1, "Minum of 1 character")
    .max(255)
    .required(isTrial ? "First Name Initial is required" : "First Name is required"),
    last_name: Yup.string()
    .min(1, "Minum of 1 character")
    .max(255)
    .required(isTrial ? "Last Name Initial is required" : "Last Name is required"),
  gender: Yup.string().required("Gender is required"),
  dob: Yup.string().required("Date of Birth  is required"),
  disease_id: Yup.string().required("Disease  is required"),
  investigator_id: Yup.string().required(
    "Principal Investigator/HCP  is required"
  ),
  editor_id: Yup.string().nullable()
});

export const addFormExportSchema = Yup.object().shape({
  // formId: Yup.string().required('Form is required'),
  // formId: Yup.array().min(1, "Question is required"),
  // questionId: Yup.array().min(1, "Question is required"),
  formId: Yup.array().min(1, "Form is required").required("Form is required"),
  questionId: Yup.array().when("formId", {
    is: (formId) => formId && formId.length > 1,
    then: Yup.array().min(1, "Question is required"),
    otherwise: Yup.array().notRequired(),
  }),
});

// validation schema for edit subject id 
export const validateEditSubjectId = Yup.object().shape({
  patientId: Yup.string().required(
    "Patient/Subject Id  is required"
  ),
});

export const ReAssignValidationSchema = Yup.object().shape({
  investigator_id: Yup.string().required(
    "Principal Investigator/HCP  is required"
  ),
  editor_id: Yup.string().nullable()
});

export const addProductValidationSchema = Yup.object().shape({
  program_code: Yup.string().required("Product Code is required"),
  productName: Yup.string()
    .min(1, "Product name must be between 1-25 character long")
    .max(25, "Product name must be between 1-25 character long")
    .required("Product Name is required"),
  description: Yup.string()
    .max(
      200,
      "Description length must be less than or equal to 200 characters long"
    )
    .required("Description is required"),
});

export const addPhaseValidationSchema = Yup.object().shape({
  phase_code: Yup.string().required("Phase Code is required"),
  title: Yup.string()
    .max(255, "Title cannot be longer than 255 characters")
    .required("Title is required"),
  phase_type: Yup.string().required("Phase Type is required"),
  phase_start_date: Yup.date()
    .typeError("Invalid date format")
    .required("Phase Start Date is required"),
  minimum_subjects: Yup.number()
    .typeError("The number of patient/subject must be a number")
    .min(1, "The minimum number of patients/subjects is 1")
    .max(10000, "The maximum number of patients/subjects is 10000")
    .required("Minimum number of patients/subjects is required"),
  coordinating_PI_id: Yup.string().required("Medical Expert is required"),
  // template_type_ids: Yup.array()
  //   .of(
  //     Yup.number()
  //       .typeError("Each ID must be a number")
  //       .required("At least one Visit type is required")
  //   )
  //   .min(1, "At least one Visit type is required")
  //   .required("Visit type is required"),
  description: Yup.string()
    .max(200, "Description must be at most 200 characters")
    .required("Description is required"),
});


export const editPhaseValidationSchema = Yup.object().shape({
  title: Yup.string()
    .max(255, "Title cannot be longer than 255 characters")
    .required("Title is required"),
  phase_type: Yup.string().required("Phase Type is required"),
  phase_start_date: Yup.date()
    .typeError("Invalid date format")
    .required("Phase Start Date is required"),
  minimum_subjects: Yup.number()
    .typeError("The number of patient/subject must be a number")
    .min(1, "The minimum number of patients/subjects is 1")
    .max(10000, "The maximum number of patients/subjects is 10000")
    .required("Minimum number of patients/subjects is required"),
  coordinating_PI_id: Yup.string().required("Medical Expert is required"),
  description: Yup.string()
    .max(200, "Description must be at most 200 characters")
    .required("Description is required"),
});


export const visitFrequencyValidationSchema = Yup.object().shape({
  template_type_ids: Yup.array()
    .of(
      Yup.number()
        .typeError("Each ID must be a number")
        .required("At least one Visit type is required")
    )
    .min(1, "At least one Visit type is required")
    .required("Visit type is required"), 
});

export const addFormTemplateValidationSchema = Yup.object().shape({
  title: Yup.string()
    .min(1, "Title must be between 1-150 characters long")
    .max(150, "Title must be between 1-150 characters long")
    .required("Title is required"),
  type: Yup.string().max(255).required("Type is required"),
  description: Yup.string()
    .max(
      255,
      "Description length must be less than or equal to 255 characters long"
    )
    .required("Description is required"),
});

export const ResendRequestValidationSchema = Yup.object().shape({
  description: Yup.string()
    .max(
      200,
      "Description length must be less than or equal to 200 characters long"
    )
    .required("Description is required"),
});

export const rolesValidationSchema = Yup.object().shape({
  title: Yup.string()
    .min(1, "Title must be between 1-50 characters long")
    .max(50, "Title must be between 1-50 characters long")
    .required("Title is required"),
  description: Yup.string()
    .max(
      200,
      "Description length must be less than or equal to 200 characters long"
    )
    .required("Description is required"),
});

export const piSubjectValidationSchema = Yup.object().shape({});

export const reAssignPiValidationSchema = Yup.object().shape({
    editor_id: Yup.string().nullable()
});

export const updatPhaseValidationSchema = Yup.object().shape({
    phase: Yup.array()
        .of(Yup.number().required("Each ID must be a number"))
        .min(1, "Phase is required"),
});

export const queryMessageValidationSchema = Yup.object().shape({
    phase: Yup.string().required('Phase is required'),
    template: Yup.string().required('Form Builder is required'),
    formField: Yup.string().required('Form Field is required'),
});


export const deathDateSchema = Yup.object().shape({
    deathDateValue: Yup.date()
        .typeError('Date of Death is required')
        .required('Date of Death is required'),
        description: Yup.string()
      .required('Description is required'),
});

export const recordedDateSchema = Yup.object().shape({
  last_recorded_visit_date: Yup.date()
      .typeError('Last recorded visit date is required')
      .required('Last recorded visit date is required'),
});

export const lostToFollowUpSchema = Yup.object().shape({
    lostToFollowUp: Yup.date()
        .typeError('Date of Last Follow Up is required')
        .required('Date of Last Follow Up is required'),
        description: Yup.string()
        .required('Description is required'),
});


export const apheresisDateRangeSchema = Yup.object().shape({
  apheresisDateRange: Yup.object()
    .shape({
      from: Yup.string(),
      to: Yup.string(),
    })
    .test(
      "date-range-required",
      "Apheresis date range is required",
      function (value) {
        // value could be undefined/null
        if (!value || (!value.from && !value.to)) {
          return this.createError({ message: "Apheresis date range is required" });
        }
        return true;
      }
    )
    .required("Apheresis date range is required"),
});


export const addPatientIdSchema = Yup.object().shape({
    patientId : Yup.string().required('Patient/Subject Id is required'),
});

export const requestModalDataSchema = Yup.object().shape({
  Select_patient_request_status:Yup.string()
  .required('Request is required'),

  Select_patient_Info_menu: Yup.mixed().test(
    'validate-Select_patient_Info_menu',
    'Request Info is required',
    function (value) {
      return value && Array.isArray(value) ? value.length > 0 : value > 0;
    }
  ),

  description: Yup.string()
      .required('Reason for change is required')
      .min(3, "Reason for change must be between 3-200 characters long")
      .max(200, "Reason for change must be between 3-200 characters long"),
 });

// validation schema for add form type 

export const addFormTypeSchema = Yup.object().shape({
  prefix: Yup.string()
    .matches(NAME_REGEX, "Enter a valid Acronym") //@info: prefix name is updated to Acronym 
    .required("Acronym is required")
    .min(2, "Acronym must be between 2-10 characters long")
    .max(10, "Acronym must be between 2-10 characters long"),
  typeName: Yup.string()
    .matches(NAME_REGEX, "Enter a valid Form Type Name")
    .required("Type Name is required")
    .min(1, "Type Name must be between 1-50 characters long")
    .max(50, "Type Name must be between 1-50 characters long")
});

export const validationSchemaForProductMaster = Yup.object().shape({
  product_ids: Yup.array()
  .of(Yup.string())         // each item is a string (or number if needed)
  .min(1, "Product Name is required")
  .required("Product Name is required"),
    description: Yup.string()
        .min(1, "Description must be between 1-255 characters long")
        .max(255, "Description must be between 1-255 characters long")
        .required("Description is required"),
    active: Yup.boolean().required("Status is required"),
    lsm_received_ed:Yup.number().required("Days is required"),
    lsm_qualification_ed:Yup.number().required("Days is required"),
    manufacturing_completion_ed:Yup.number().required("Days is required"),
    qc_testing_ed:Yup.number().required("Days is required"),
    qa_review_ed:Yup.number().required("Days is required"),
    expiry_date:Yup.number().required("Days is required"),
    cryo_manufacturing_date:Yup.number().required("Days is required"),
    cryo_manufacturing_completion_ed:Yup.number().required("Days is required"),
    cryo_qc_testing_ed:Yup.number().required("Days is required"),
    cryo_qa_review_ed:Yup.number().required("Days is required"),
});